import { connect } from 'react-redux';
import {
  fetchPosHoldsOrders, fetchPosHoldsOrdersDetail, voidSelectedPosHoldsOrder,
  printPosHolds,
} from '../../actions/pos_actions';
import { setConfirmPasscodeModalVisibility, setPasscodeVerificationStatus } from '../../actions/baseModal_actions';

import PosHolds from '../../components/Sales/posHolds';

function mapStateToProps(state) {
  return {
    posHolds: state.pos.posHolds,
    posHoldsOderDetail: state.pos.posHoldsOderDetail,
    confirmPasscodeVerified: state.baseModals.confirmPasscodeModal.verified,
    requestingPosHoldsPDF: state.pos.requestingPosHoldsPDF,
    posHoldsPDF: state.pos.posHoldsPDF,
  };
}

export default connect(mapStateToProps, {
  fetchPosHoldsOrders,
  fetchPosHoldsOrdersDetail,
  voidSelectedPosHoldsOrder,
  printPosHolds,
  setConfirmPasscodeModalVisibility,
  setPasscodeVerificationStatus,
})(PosHolds);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/posHolds.jsx